module.exports = __webpack_public_path__ + "img/IMG_20201124_005755.0a7e5ce8.jpg";